import React from 'react';
import classNames from 'classnames';
import { StatusBadgeProps, StatusBadgeVariant } from './types';
import styles from './styles.module.scss';

/*
 * Maps status-badge variants to V1's dark-theme color palette — a dark, saturated fill paired
 * with a bright dot, matching the pill/dot convention in src/pages/cluster_redisign (the
 * reference "proper V1 theme" for status pills) rather than a flat/translucent tag.
 */
const VARIANT_STYLE_MAP: Record<StatusBadgeVariant, { background: string; dot: string }> = {
    success: { background: '#0a3d24', dot: '#08c46a' },
    info: { background: '#0d3049', dot: '#1890ff' },
    warning: { background: '#4a3300', dot: '#fcad01' },
    destructive: { background: '#4a1111', dot: '#ff4d4f' },
    secondary: { background: '#363859', dot: '#9a9db8' },
};

/*
 * Colored status pill with a leading dot indicator, matching V1's cluster-page badge convention
 */
export function StatusBadge({ variant, children, className }: StatusBadgeProps) {
    const { background, dot } = VARIANT_STYLE_MAP[variant];
    return (
        <span className={classNames(styles.statusBadge, className)} style={{ backgroundColor: background }}>
            <span className={styles.dot} style={{ backgroundColor: dot }} />
            {children}
        </span>
    );
}
